export const SET_CURRENT_MEETING = "setCurrentMeeting";
export const SET_SPLASH_PAGE = "setSplashPage";
export const SET_ACCESS_CODE = "setAccessCode";
export const SET_VALID_CODE = "setValidCode";
export const SET_SESSION = "setSession";
export const SET_AUTHENTICATION_ZONE = "setAuthenticationZone";
export const SET_TITLE = "setTitle";
export const SET_TEMPLATE = "setTemplate";
export const SET_ERROR = "setError";
export const SET_TEMPLATE_PATH = "setTemplatePath";
export const SET_TEMPLATE_VARIABLES = "setTemplateVariables";
export const SET_ENTITY = "setEntity";
export const SET_MOTD = "setMotd";